import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  onIndustrySelect: (industry: string) => void;
}

const HeroSection = ({ onIndustrySelect }: HeroSectionProps) => {
  const industries = [
  { id: 'banking', name: 'Banking', icon: 'BuildingLibraryIcon' },
  { id: 'aviation', name: 'Aviation', icon: 'RocketLaunchIcon' },
  { id: 'government', name: 'Government', icon: 'BuildingOffice2Icon' },
  { id: 'corporate', name: 'Corporate', icon: 'BriefcaseIcon' }];


  return (
    <section className="relative bg-gradient-to-br from-primary via-brand-navy to-secondary min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-r from-brand-gold to-accent"></div>
      </div>
      
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-6">
            <h1 className="text-5xl lg:text-6xl font-headline font-bold leading-tight">
              Where Corporate Identity Meets Craftsmanship
            </h1>
            <p className="text-xl font-body text-gray-200 leading-relaxed">
              Trusted by Tanzania's leading institutions to deliver premium uniform solutions that embody professional excellence and institutional pride.
            </p>
            
            <div className="flex flex-wrap gap-4 pt-4">
              <button
                onClick={() => onIndustrySelect('all')}
                className="px-8 py-4 bg-brand-gold text-brand-gold-foreground font-cta font-semibold rounded-lg hover:bg-opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">

                Request Consultation
              </button>
              <button
                onClick={() => onIndustrySelect('portfolio')}
                className="px-8 py-4 bg-white bg-opacity-10 backdrop-blur-sm text-white font-cta font-semibold rounded-lg hover:bg-opacity-20 transition-all duration-300 border border-white border-opacity-30">

                View Our Work
              </button>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-8">
              {industries.map((industry) =>
              <button
                key={industry.id}
                onClick={() => onIndustrySelect(industry.id)}
                className="flex flex-col items-center p-4 bg-white bg-opacity-10 backdrop-blur-sm rounded-lg hover:bg-opacity-20 transition-all duration-300 group">

                  <Icon
                  name={industry.icon as any}
                  size={32}
                  variant="outline"
                  className="text-brand-gold group-hover:scale-110 transition-transform duration-300" />

                  <span className="text-sm font-body font-medium mt-2 text-white">
                    {industry.name}
                  </span>
                </button>
              )}
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative w-full h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <AppImage
                src="https://img.rocket.new/generatedImages/rocket_gen_img_124ff494f-1767434350548.png"
                alt="Professional African business team in matching navy blue corporate uniforms standing confidently in modern office lobby"
                className="w-full h-full object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-primary via-transparent to-transparent opacity-60"></div>
            </div>
            
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-2xl max-w-xs">
              <div className="flex items-start space-x-4">
                <Icon name="CheckBadgeIcon" size={40} variant="solid" className="text-success flex-shrink-0" />
                <div>
                  <p className="text-sm font-body font-semibold text-text-primary">
                    Trusted by 50+ Major Institutions
                  </p>
                  <p className="text-xs text-text-secondary mt-1">
                    Including NMB Bank, TRA, and ATCL
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;